/**
 * Phase 1A · Fulfillment Queue Sort By — canonical options + helper.
 *
 * Extracted from `FulfillmentAdmin.jsx` so the option list, default,
 * and value-safety guard can be unit-tested without spinning up the
 * whole queue component.
 */
export const FULFILLMENT_SORT_OPTIONS = [
  { value: "newest",             label: "Newest Orders First" },
  { value: "oldest",             label: "Oldest Orders First" },
  { value: "priority",           label: "Highest Priority First" },
  { value: "waiting_longest",    label: "Oldest Waiting for Action" },
  { value: "recently_paid",      label: "Recently Paid" },
  { value: "recently_updated",   label: "Recently Updated" },
];

export const DEFAULT_FULFILLMENT_SORT = "newest";

const VALID = new Set(FULFILLMENT_SORT_OPTIONS.map((o) => o.value));

export function safeFulfillmentSort(value) {
  const v = String(value || "").trim().toLowerCase();
  return VALID.has(v) ? v : DEFAULT_FULFILLMENT_SORT;
}

export function loadPersistedSort(sessionStorageLike, key = "collectorup:fulfillment-queue") {
  try {
    const raw = sessionStorageLike?.getItem(key);
    if (!raw) return DEFAULT_FULFILLMENT_SORT;
    return safeFulfillmentSort(JSON.parse(raw)?.sortBy);
  } catch {
    return DEFAULT_FULFILLMENT_SORT;
  }
}
